/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ReImportSpecification,
  ReportConfigCreateRequest,
  ReportConfigRepresentation,
  ReportConfigUpdateRequest,
  ReportCreateRequest,
  ReportRepresentation,
  ReportResultRequest,
  ReportRetryRequest,
} from '../models/index';
import {
    ReImportSpecificationFromJSON,
    ReImportSpecificationToJSON,
    ReportConfigCreateRequestFromJSON,
    ReportConfigCreateRequestToJSON,
    ReportConfigRepresentationFromJSON,
    ReportConfigRepresentationToJSON,
    ReportConfigUpdateRequestFromJSON,
    ReportConfigUpdateRequestToJSON,
    ReportCreateRequestFromJSON,
    ReportCreateRequestToJSON,
    ReportRepresentationFromJSON,
    ReportRepresentationToJSON,
    ReportResultRequestFromJSON,
    ReportResultRequestToJSON,
    ReportRetryRequestFromJSON,
    ReportRetryRequestToJSON,
} from '../models/index';

export interface CreateReportConfigRequest {
    reportConfigCreateRequest?: ReportConfigCreateRequest;
}

export interface GetAffectedReImportSpecificationsRequest {
    documentKeys?: Array<string>;
    dashboardKey?: string;
}

export interface GetReportConfigRequest {
    reportConfigKey: string;
}

export interface GetReportConfigsRequest {
    dashboardKey?: string;
}

export interface ProcessReportResultRequest {
    xAUTH: string;
    reportResultRequest?: ReportResultRequest;
}

export interface RetryReportRequest {
    reportRetryRequest?: ReportRetryRequest;
}

export interface StartReportGenerationRequest {
    reportCreateRequest?: ReportCreateRequest;
}

export interface UpdateReportConfigRequest {
    reportConfigKey: string;
    reportConfigUpdateRequest?: ReportConfigUpdateRequest;
}

/**
 * 
 */
export class ReportsApi extends runtime.BaseAPI {

    /**
     * Create a new report config
     * Create a new report config
     */
    async createReportConfigRaw(requestParameters: CreateReportConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportConfigRepresentation>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["reports:manage"]);
        }


        let urlPath = `/report-configs`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReportConfigCreateRequestToJSON(requestParameters['reportConfigCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportConfigRepresentationFromJSON(jsonValue));
    }

    /**
     * Create a new report config
     * Create a new report config
     */
    async createReportConfig(reportConfigCreateRequest?: ReportConfigCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportConfigRepresentation> {
        const response = await this.createReportConfigRaw({ reportConfigCreateRequest: reportConfigCreateRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Get all re-import specifications related to a report document
     * Get related re-import specifications
     */
    async getAffectedReImportSpecificationsRaw(requestParameters: GetAffectedReImportSpecificationsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<{ [key: string]: Array<ReImportSpecification>; }>> {
        const queryParameters: any = {};

        if (requestParameters['documentKeys'] != null) {
            queryParameters['documentKeys'] = requestParameters['documentKeys']!.join(runtime.COLLECTION_FORMATS["csv"]);
        }

        if (requestParameters['dashboardKey'] != null) {
            queryParameters['dashboardKey'] = requestParameters['dashboardKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["reports:manage"]);
        }


        let urlPath = `/reports/affectedReImportSpecifications`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse<any>(response);
    }

    /**
     * Get all re-import specifications related to a report document
     * Get related re-import specifications
     */
    async getAffectedReImportSpecifications(documentKeys?: Array<string>, dashboardKey?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<{ [key: string]: Array<ReImportSpecification>; }> {
        const response = await this.getAffectedReImportSpecificationsRaw({ documentKeys: documentKeys, dashboardKey: dashboardKey }, initOverrides);
        return await response.value();
    }

    /**
     * Get the report config with the specified key
     * Get the report config with the specified key
     */
    async getReportConfigRaw(requestParameters: GetReportConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportConfigRepresentation>> {
        if (requestParameters['reportConfigKey'] == null) {
            throw new runtime.RequiredError(
                'reportConfigKey',
                'Required parameter "reportConfigKey" was null or undefined when calling getReportConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["reports:manage"]);
        }


        let urlPath = `/report-configs/{reportConfigKey}`;
        urlPath = urlPath.replace(`{${"reportConfigKey"}}`, encodeURIComponent(String(requestParameters['reportConfigKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportConfigRepresentationFromJSON(jsonValue));
    }

    /**
     * Get the report config with the specified key
     * Get the report config with the specified key
     */
    async getReportConfig(reportConfigKey: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportConfigRepresentation> {
        const response = await this.getReportConfigRaw({ reportConfigKey: reportConfigKey }, initOverrides);
        return await response.value();
    }

    /**
     * Get all report configs matching the filter parameters
     * Get all report configs matching the filter parameters
     */
    async getReportConfigsRaw(requestParameters: GetReportConfigsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ReportConfigRepresentation>>> {
        const queryParameters: any = {};

        if (requestParameters['dashboardKey'] != null) {
            queryParameters['dashboardKey'] = requestParameters['dashboardKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["reports:manage"]);
        }


        let urlPath = `/report-configs`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ReportConfigRepresentationFromJSON));
    }

    /**
     * Get all report configs matching the filter parameters
     * Get all report configs matching the filter parameters
     */
    async getReportConfigs(dashboardKey?: string, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ReportConfigRepresentation>> {
        const response = await this.getReportConfigsRaw({ dashboardKey: dashboardKey }, initOverrides);
        return await response.value();
    }

    /**
     * Processes a result of a report generation by document key and version
     * Processes a result of a report generation
     */
    async processReportResultRaw(requestParameters: ProcessReportResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['xAUTH'] == null) {
            throw new runtime.RequiredError(
                'xAUTH',
                'Required parameter "xAUTH" was null or undefined when calling processReportResult().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (requestParameters['xAUTH'] != null) {
            headerParameters['X-AUTH'] = String(requestParameters['xAUTH']);
        }

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["X-AUTH"] = await this.configuration.apiKey("X-AUTH"); // X-AUTH authentication
        }


        let urlPath = `/reports/results`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReportResultRequestToJSON(requestParameters['reportResultRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Processes a result of a report generation by document key and version
     * Processes a result of a report generation
     */
    async processReportResult(xAUTH: string, reportResultRequest?: ReportResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.processReportResultRaw({ xAUTH: xAUTH, reportResultRequest: reportResultRequest }, initOverrides);
    }

    /**
     * Retry a report by document key
     * Retry a report
     */
    async retryReportRaw(requestParameters: RetryReportRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["reports:manage"]);
        }


        let urlPath = `/reports/retries`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReportRetryRequestToJSON(requestParameters['reportRetryRequest']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Retry a report by document key
     * Retry a report
     */
    async retryReport(reportRetryRequest?: ReportRetryRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.retryReportRaw({ reportRetryRequest: reportRetryRequest }, initOverrides);
    }

    /**
     * Start generating the report with the spec
     * Start generating a report
     */
    async startReportGenerationRaw(requestParameters: StartReportGenerationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportRepresentation>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["reports:manage"]);
        }


        let urlPath = `/reports`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ReportCreateRequestToJSON(requestParameters['reportCreateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportRepresentationFromJSON(jsonValue));
    }

    /**
     * Start generating the report with the spec
     * Start generating a report
     */
    async startReportGeneration(reportCreateRequest?: ReportCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportRepresentation> {
        const response = await this.startReportGenerationRaw({ reportCreateRequest: reportCreateRequest }, initOverrides);
        return await response.value();
    }

    /**
     * Update the report config with the specified key
     * Update the report config with the specified key
     */
    async updateReportConfigRaw(requestParameters: UpdateReportConfigRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ReportConfigRepresentation>> {
        if (requestParameters['reportConfigKey'] == null) {
            throw new runtime.RequiredError(
                'reportConfigKey',
                'Required parameter "reportConfigKey" was null or undefined when calling updateReportConfig().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["reports:manage"]);
        }


        let urlPath = `/report-configs/{reportConfigKey}`;
        urlPath = urlPath.replace(`{${"reportConfigKey"}}`, encodeURIComponent(String(requestParameters['reportConfigKey'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: ReportConfigUpdateRequestToJSON(requestParameters['reportConfigUpdateRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ReportConfigRepresentationFromJSON(jsonValue));
    }

    /**
     * Update the report config with the specified key
     * Update the report config with the specified key
     */
    async updateReportConfig(reportConfigKey: string, reportConfigUpdateRequest?: ReportConfigUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ReportConfigRepresentation> {
        const response = await this.updateReportConfigRaw({ reportConfigKey: reportConfigKey, reportConfigUpdateRequest: reportConfigUpdateRequest }, initOverrides);
        return await response.value();
    }

}
